import {
  spacingHelper,
  paletteHelper,
  mediaHelper,
  boxShadow,
  radiusHelper,
} from '@property.com.au/ui-kit';
import styled from 'styled-components';

export const ChatWrapper = styled.div`
  position: fixed;
  background-color: ${paletteHelper('backgroundPrimary')};
  z-index: 101;
  height: 100dvh; /* stylelint-disable-line plugin/no-unsupported-browser-features */
  width: 100dvw; /* stylelint-disable-line plugin/no-unsupported-browser-features */
  bottom: 0;
  right: 0;
  ${boxShadow.modalBoxShadow};

  ${mediaHelper('tabletMin')} {
    width: 432px;
    height: 714px;
    bottom: ${spacingHelper('medium')};
    right: ${spacingHelper('medium')};
    border-radius: ${radiusHelper('large')};
  }
`;
